import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';
import { AccordionModule } from 'primeng/accordion';
import { DirectiveModule } from '@Directive/directive.module';

import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppLayoutComponent } from './app.layout.component';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { AppSidebarComponent } from './app.sidebar.component';
import { AppTopbarComponent } from './app.topbar.component';
import { AppConfigModule } from './config/app.config.module';
import { NeedHelpModalComponent } from './need-help-modal/need-help-modal.component';
import { ComponentsModule } from 'app/main/apps/components/components.module';
import { FaqComponent } from './need-help-modal/faq/faq.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CommonModule } from '@angular/common';
import { ChangeOrganizationModalComponent } from './change-organization-modal/change-organization-modal.component';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
    declarations: [
        AppBreadcrumbComponent,
        AppLayoutComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppSidebarComponent,
        AppTopbarComponent,
        NeedHelpModalComponent,
        FaqComponent,
        ChangeOrganizationModalComponent,
    ],
    imports: [
        AppConfigModule,
        CommonModule,
        BrowserAnimationsModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        TranslateModule,
        DirectiveModule,
        // PrimeNG modules
        BadgeModule,
        ButtonModule,
        TableModule,
        SkeletonModule,
        // CalendarModule,
        InputSwitchModule,
        InputTextModule,
        RadioButtonModule,
        RippleModule,
        SidebarModule,
        StyleClassModule,
        TooltipModule,
        InputTextareaModule,
        AccordionModule,
        ScrollPanelModule,
    ],
})
export class AppLayoutModule {}
